import { Box, ChakraProvider, extendTheme } from "@chakra-ui/react";
import { getDefaultWallets, RainbowKitProvider } from "@rainbow-me/rainbowkit";
import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { chain, configureChains, createClient, WagmiConfig } from "wagmi";
import { alchemyProvider } from "wagmi/providers/alchemy";
import { publicProvider } from "wagmi/providers/public";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import analyticsInstance from "./config/analytics";
import Main from "./pages/Main";
import FAQ from "./pages/FAQ";
import Success from "./pages/Success";
import Wallet from "./pages/Wallet";

import "@rainbow-me/rainbowkit/styles.css";

// global styles for chakra
const theme = extendTheme({
  styles: {
    global: (props) => ({
      a: {
        _hover: {
          color: "orange.500",
          textDecoration: "none", // not working
        },
      },
    }),
  },
});

// react setup
const container = document.getElementById("root");
const root = createRoot(container);

// wagmi+rainbowkit setup
const { chains, provider, webSocketProvider } = configureChains(
  [chain.polygon, chain.polygonMumbai /*, chain.hardhat*/],
  // [alchemyProvider({ apiKey: "lUi2aW8Xp_7n-E8LXsMO-bJ7yHw5wzOc", priority: 0 }), publicProvider({ priority: 1 })]
  [publicProvider()]
);
const { connectors } = getDefaultWallets({
  appName: "BTFDCA",
  chains,
});
const client = createClient({
  autoConnect: true,
  connectors,
  provider,
  webSocketProvider,
});

function App() {
  const location = useLocation();

  useEffect(() => {
    // send page view on route change
    analyticsInstance.page();
  }, [location]);

  return (
    <>
      <ScrollToTop />
      <React.StrictMode>
        <Header />
        <Box as="main" minH="100vh">
          <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/success" element={<Success />} />
            <Route path="/wallet" element={<Wallet />} />
          </Routes>
        </Box>
        <Footer />
      </React.StrictMode>
    </>
  );
}

root.render(
  <WagmiConfig client={client}>
    <RainbowKitProvider coolMode chains={chains}>
      <ChakraProvider theme={theme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ChakraProvider>
    </RainbowKitProvider>
  </WagmiConfig>
);
